module.exports = __webpack_public_path__ + "media/images/cancellation-error-031463b57847ebd8354b305bc42f4082.svg";